module.exports = __webpack_public_path__ + "static/media/logo.f15c72ea.svg";